"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SearchResultsTextMiddle = /** @class */ (function (_super) {
    __extends(SearchResultsTextMiddle, _super);
    function SearchResultsTextMiddle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultsTextMiddle.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-9" },
                    React.createElement("a", { href: "https://floir.com/docs-sf/default-source/documents-from-old-website/choices-documents/medsupplancharts.pdf", style: { textDecoration: 'underline' }, target: "_blank", rel: "noopener noreferrer" }, "Outline of Standardized Plan")),
                React.createElement("div", { className: "col-md-3" }, "Annual Premiums"))));
    };
    return SearchResultsTextMiddle;
}(React.PureComponent));
;
exports.default = SearchResultsTextMiddle;
//# sourceMappingURL=SearchResultsTextMiddle.js.map